import type { ReferentialityAPI } from '@atlassian/editor-referentiality';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export { useConnectionsPanel } from '../src/ConnectionsPanel/useConnectionsPanel.ts';
export const EditorContextConnectionsPanel: LoadableType<{
	api: ReferentialityAPI;
	activeNodeLocalId: string;
	closeConnectionsPanel: (localId?: string) => void;
	setActiveNodeLocalId: (localId: string) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-appreferentiality" */ '../src/ConnectionsPanel/EditorContextConnectionsPanel.tsx'
			)
		).EditorContextConnectionsPanel,
});
